import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-base leading-6 font-medium text-black" }, "Object property", -1)
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col mb-4"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "bg-gray-200 mt-8 mb-4 w-[445px] -mx-6" }, null, -1)
const _hoisted_5 = { class: "text-base leading-6 font-medium text-black pt-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "bg-gray-200 mt-8 mb-4 w-[445px] -mx-6" }, null, -1)
const _hoisted_7 = { class: "text-base leading-6 font-medium text-black py-4" }

import { computed, onMounted, ref, watch } from "vue"
import GgmsDropdown from "@/components/GgmsDropdown.vue"
import FilterRule from "@/components/filters/FilterRule.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import FilterList from "@/components/filters/FilterList.vue"
import { useGridCollectionStore } from "@/stores/grid-collection"
import { useWorkflowStore } from "@/stores/workflow"
import { Filter } from "@/shared/models/filter"


export default /*#__PURE__*/_defineComponent({
  __name: 'SinglePropertyComponent',
  emits: ["setButtonsStatus"],
  setup(__props) {

const workflowStore = useWorkflowStore()
const gridCollectionStore = useGridCollectionStore()



const prototypes = computed(() => {
    gridCollectionStore.getPrototypesByPage("leads")
    return gridCollectionStore.prototypes
})

const isEditFilter = ref(false)

function isCurrentFilterStep(step: string) {
    return workflowStore.branches[0]?.currentStep === step
}

function applyFilter(filter: Filter) {
    if (["body"].includes(filter.field)) {
        filter.field = `messages.${filter.field}`
    }

    isEditFilter.value ? editFilterGroup(filter) : addFilterToGroup(filter)
    openFiltersList()
    workflowStore.areButtonDisabled = false
}

function addFilterToGroup(filter: Filter) {
    // TODO - we need to discuss about object type
    if (filter.field === "phones") {
        filter.field = "phones.number"
    } else if (filter.field === "emails") {
        filter.field = "emails.emailAddress"
    }
    const branch = workflowStore.branches[0]
    if (!branch) {
        return
    }

    if (!branch?.filtersGroups?.at(branch.selectedFilterGroup!)) {
        workflowStore.branches.at(0)?.filtersGroups?.push({ filters: [filter] })
        return
    }
    workflowStore.branches.at(0)?.filtersGroups?.at(branch.selectedFilterGroup!)?.filters.push(filter)
}

function editFilterGroup(filter: Filter) {
    if (filter.field === "phones") {
        filter.field = "phones.number"
    } else if (filter.field === "emails") {
        filter.field = "emails.emailAddress"
    }
    const branch = workflowStore.branches[0]
    workflowStore.branches[0].filtersGroups[branch.selectedFilterGroup].filters[branch.selectedFilterIndex] = filter
}

function openFiltersList() {
    workflowStore.branches[0].currentStep = "filterList"
}

function cancelFilter() {
    resetSelectedFilter()
    openFiltersList()
}
function resetSelectedFilter() {
    workflowStore.branches[0].selectedFilter = {
        field: "",
        type: "",
        rule: "",
        value: "",
    }
}

function openFilterRulesList() {
    const property = getAttributeByName(workflowStore.modelValue)
    workflowStore.branches[0].selectedFilter = {
        field: property?.name,
        type: property?.type,
        displayName: property?.displayName,
        value: "",
        rule: "",
    }

    workflowStore.branches[0].currentStep = "filterRule"
    isEditFilter.value = false
}

function editFilter(filter: Filter, filterIndex: number) {
    isEditFilter.value = true
    workflowStore.branches[0].selectedFilter = {
        field: filter.field,
        type: filter.type as string,
        value: filter.value as string,
        rule: filter.rule,
        displayName: filter.displayName as string,
    }
    workflowStore.branches[0].currentStep = "filterRule"
    workflowStore.branches[0].selectedFilterIndex = filterIndex
}

function clearBranchFilters() {
    workflowStore.branches[0].currentStep = undefined
    // gridCollectionStore.clearFilters()
    workflowStore.branches[0].selectedFilter = {
        field: "",
        type: "",
        rule: "",
        value: "",
        displayName: "",
    }
    workflowStore.branches[0].filtersGroups = []
    workflowStore.areButtonDisabled = true
}

async function clearFilters() {
    workflowStore.branches[0].currentStep = undefined
    clearBranchFilters()
    workflowStore.branches[0].selectedFilter = {
        field: "",
        type: "",
        rule: "",
        value: "",
        displayName: "",
    }
    workflowStore.modelValue = ""
    workflowStore.areButtonDisabled = true
}

function getAttributeByName(name: string) {
    return prototypes.value[0].attributes.find((attribute) => attribute.name === name)
}

onMounted(() => {
    gridCollectionStore.getPrototypesByPage("leads")
})

watch(
    () => workflowStore.noneBranch?.value,
    () => (workflowStore.areButtonDisabled = false)
)

watch(
    () => workflowStore.modelValue,
    () => {
        if (!workflowStore.modelValue) {
            return
        }
        const property = getAttributeByName(workflowStore.modelValue)
        workflowStore.branches[0].selectedFilter = {
            field: property?.name,
            type: property?.type,
            displayName: property?.displayName,
            rule: "",
            value: "",
        }
        workflowStore.branches[0].currentStep = "filterRule"
        workflowStore.branches[0].filtersGroups = []
        // clearBranchFilters()
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(GgmsDropdown, {
      modelValue: _unref(workflowStore).modelValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).modelValue) = $event)),
      class: "mt-3 w-full text-ellipsis",
      options: prototypes.value[0].attributes,
      optionLabel: "displayName",
      optionValue: "name",
      placeholder: "Select object property",
      panelClass: "w-20 text-ellipsis"
    }, null, 8, ["modelValue", "options"]),
    (_unref(workflowStore).modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, " If '" + _toDisplayString(_unref(workflowStore).branches[0]?.selectedFilter?.displayName ||
                    _unref(workflowStore).branches[0]?.selectedFilter?.[0]?.displayName ||
                    "Object property") + "' : ", 1)
        ]))
      : _createCommentVNode("", true),
    (isCurrentFilterStep('filterRule'))
      ? (_openBlock(), _createBlock(FilterRule, {
          key: 1,
          filter: _unref(workflowStore).branches[0]?.selectedFilter!,
          isUpdated: isEditFilter.value,
          showHeader: false,
          onApplyFilter: applyFilter,
          onCancel: cancelFilter
        }, null, 8, ["filter", "isUpdated"]))
      : _createCommentVNode("", true),
    (isCurrentFilterStep('filterList'))
      ? (_openBlock(), _createBlock(FilterList, {
          key: 2,
          savedFiltersGroups: _unref(workflowStore).branches[0].filtersGroups,
          isWorkflow: true,
          onAddNewFilter: openFilterRulesList,
          onEditFilter: editFilter,
          onClearFilters: clearFilters
        }, null, 8, ["savedFiltersGroups"]))
      : _createCommentVNode("", true),
    _hoisted_6,
    _createElementVNode("p", _hoisted_7, " If ‘" + _toDisplayString(_unref(workflowStore).branches[0]?.selectedFilter?.displayName || "Object property") + "’ is none of the above go here: ", 1),
    _createVNode(GgmsInput, {
      modelValue: _unref(workflowStore).noneBranch.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(workflowStore).noneBranch.value) = $event)),
      label: "‘None’ branch name",
      placeholder: "None"
    }, null, 8, ["modelValue"])
  ]))
}
}

})